export default "__VITE_ASSET__D6EMEz6e__"